import React, { useState } from "react";
import { Card, Button } from "antd";
import { BankOutlined } from "@ant-design/icons"; // Placeholder icon
import { formatCurrencyWithoutCode } from "../../utils/helper/format";
import { useNavigate } from "react-router-dom";
import SelectAccoutModal from "../Payment Methods/Modals/SelectAccoutModal";
import { useDashboard } from "../../store/context/DashboardContext";
import { useTheme } from "../../store/context/theme-context";
import { useTenant } from "../../store/context/tenant-context";

const AccountSummaryCard = () => {
  const tenant = useTenant();
  const { theme } = useTheme();

  const { depositPolicies } = useDashboard();
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(
    depositPolicies[0]?.accountNumber
  );
  console.log("selectedAccount is", selectedAccountNumber);

  const handleAccountSelection = (accountNumber) => {
    // console.log("accountNumber", accountNumber);
    // console.log("accountDetails", accountDetails);
    setSelectedAccountNumber(accountNumber);
    setIsModalVisible(false);
  };

  const accountDetails = depositPolicies?.find(
    (item) => item.accountNumber === selectedAccountNumber
  );
  return (
    <>
      <SelectAccoutModal
        isModalVisible={isModalVisible}
        handleCancel={() => setIsModalVisible(false)}
        handleOk={handleAccountSelection}
      />
      <Card
        className="w-full border border-gray-300 rounded-lg shadow-md"
        style={{ background: "transparent" }}
        bodyStyle={{ padding: "15px" }} // ✅ Keeps proper spacing
      >
        <div className="flex flex-row items-start w-full">
          {/* Column 1: Icon */}
          <div className="flex items-start justify-center w-10">
            {/* <BankOutlined className="text-xl text-gray-700" /> */}
            <img
              src={theme === "dark" ? tenant.darkLogo : tenant.logo}
              alt={tenant?.companyName}
              style={{ width: 20, height: 20 }}
            />
          </div>

          {/* ✅ Column 2: Account Details (Increased Vertical Spacing) */}
          <div className="flex flex-col w-full pr-6 space-y-2 md:w-2/5">
            {" "}
            {/* ✅ Added space-y-2 for spacing */}
            <b className="text-sm font-semibold ">
              {accountDetails?.accountHolder}
            </b>
            {depositPolicies.length > 1 && (
              <p
                onClick={() => setIsModalVisible(true)}
                className="text-sm font-medium cursor-pointer text-gray-600f"
              >
                Switch account
              </p>
            )}
            <p className="text-sm text-gray-600f">
              Account Number: {accountDetails?.accountNumber}
            </p>
            <p className="text-sm text-gray-600f">
              {accountDetails?.accountType}
            </p>
          </div>

          {/* ✅ Column 3: Bold Account Balance (Reduced to 20%) */}
          <div className="flex flex-col items-end w-1/5 pr-2">
            <b className="text-sm whitespace-nowrap">
              {accountDetails?.currency}{" "}
              {formatCurrencyWithoutCode(accountDetails?.accountBalance)}
            </b>
          </div>

          {/* ✅ Thin Vertical Separator */}
          <div className="hidden md:block w-[1px] bg-gray-300 self-stretch mx-4"></div>

          {/* ✅ Column 4: Action Buttons (Spacing & Labels Fixed) */}
          <div className="flex flex-col w-1/4 gap-2 pl-4">
            <Button
              type="default"
              onClick={() => navigate("/bills-payment")}
              className="w-full px-4 py-1 overflow-hidden text-xs font-medium border border-gray-300 whitespace-nowrap text-ellipsis"
            >
              Make a Payment
            </Button>
            <Button
              type="default"
              onClick={() => navigate("/account-statement")}
              className="w-full px-4 py-1 overflow-hidden text-xs font-medium border border-gray-300 whitespace-nowrap text-ellipsis"
            >
              View Transactions
            </Button>
            <Button
              type="default"
              onClick={() => navigate("/account-statement")}
              className="w-full px-4 py-1 overflow-hidden text-xs font-medium border border-gray-300 whitespace-nowrap text-ellipsis"
            >
              Account Details
            </Button>
          </div>
        </div>
      </Card>
    </>
  );
};

// Example Usage:
export const exampleAccount = {
  owner: "OWA OT",
  balance: 43700000054.86,
  number: "0043003043",
  sortCode: "560064",
};

export default AccountSummaryCard;
